<div class="position-relative">
  <div class="facial-recognition-header">
    <button *ngIf="showBackButton" class="btn px-3 pt-3 d-lg-none d-block" (click)="backButton()">
      <a class="cursor-pointer facial-recognition-back-button text-danger d-flex align-items-center">
        <span class="icon material-icons fw-bold pe-1">chevron_left</span>
        <span class="font-size-14 fw-bold">{{ 'facial.recognition.back.to.account' | translate }}</span>
      </a>
    </button>
    <div class="facial-recognition-text-div px-3 pt-lg-3 pt-2">
      <div class="facial-recognition-heading">
        {{ facialRecognitionHeading }}
      </div>
      <div class="facial-recognition-subheading font-size-14">
        {{ facialRecognitionSubheading }}
      </div>
    </div>
  </div>
</div>
<div *ngIf="showCloseButton" class="position-absolute top-0 end-0 cursor-pointer d-lg-block d-none" (click)="close()">
  <span class="icon material-icons font-size-20 p-2">close</span>
</div>
